import { MentionsLegales } from "bc-front-sagacomponents";
import React, { useEffect } from "react";
// import { useCookies } from "react-cookie";
import Layout from "../../components/Layout";

interface Props {
  classes?: any;
}

const MentionsLegalesPage = (props: Props) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Layout>
      <MentionsLegales />
    </Layout>
  );
};

export default MentionsLegalesPage;
